import React from "react";
import { Box, Button, Typography } from "@mui/material";
import DesktopWindowsOutlinedIcon from "@mui/icons-material/DesktopWindowsOutlined";
import { useNavigate } from "react-router-dom";

const MobileWarn: React.FC<{}> = () => {
  const GradientDesktopIcon = () => (
    <>
      <svg width={0} height={0}>
        <linearGradient id="linearColors" x1={1} y1={0} x2={1} y2={1}>
          <stop offset={0} stopColor="#7232FB" />
          <stop offset={1} stopColor="#41B0F8" />
        </linearGradient>
      </svg>
      <DesktopWindowsOutlinedIcon
        style={{
          fontSize: "62px",
          marginBottom: "12px",
          marginLeft: "-12px",
        }}
        sx={{ fill: "url(#linearColors)" }}
      />
    </>
  );
  const navigate = useNavigate();
  const handleLogout = () => {
    const clearLocalStorage = async () => {
      const viewedTipsPersistance = localStorage.getItem("viewedTips");
      await localStorage.clear();
      if (viewedTipsPersistance) {
        localStorage.setItem("viewedTips", "true");
      }
    };
    clearLocalStorage();
    navigate("/");
  };
  return (
    <Box
      style={{
        position: "absolute",
        left: "50%",
        top: "50%",
        width: "80%",
        textAlign: "center",
        transform: "translate(-50%, -50%)",
      }}
    >
      <GradientDesktopIcon />
      <Typography
        style={{
          background:
            "var(--delend-gradients-gradient-01, linear-gradient(127deg, #7232FB 12.41%, #41B0F8 87.99%))",
          backgroundClip: "text",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          fontFamily: "Poppins",
          fontSize: "32px",
          fontStyle: "normal",
          fontWeight: "600",
          lineHeight: "40px",
        }}
      >
        Opss...
      </Typography>
      <Typography
        style={{
          fontFamily: "Poppins",
          fontSize: "20px",
          fontWeight: 600,
          lineHeight: "28px",
          marginTop: "24px",
        }}
      >
        Este serviço ainda não está disponível para o celular.
      </Typography>
      <Typography
        style={{
          fontFamily: "Poppins",
          fontSize: "16px",
          fontWeight: 400,
          lineHeight: "24px",
          marginTop: "24px",
        }}
      >
        Por favor, acesse a plataforma pelo <b>computador</b> para simular
        gratuitamente e contratar a antecipação de parcelas.
      </Typography>
      <Button
        variant="outlined"
        onClick={handleLogout}
        sx={{
          textTransform: "none",
          borderRadius: 50,
          color: "#820AD1",
          borderColor: "#E9EBF0",
          px: "16px",
          py: "10px",
          mt: 4,
          width: "100%",
          "&:hover": { color: "#fff", background: "#820AD1" },
        }}
      >
        <Typography
          sx={{
            fontWeight: 500,
            fontSize: 14,
          }}
          color="inherit"
          noWrap
        >
          sair
        </Typography>
      </Button>
    </Box>
  );
};

export default MobileWarn;
